import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable()
export class GlobalService extends BaseService {

    public readonly EDUCADOR=15;
    public readonly EMPRESA=16;
    public readonly ALUNO=17;


    public loggedUser = null;
    public token = null;

    constructor(
        public http: HttpClient,
        public router: Router
    ) {
        super(http, 'api', 'v2');
        
        let user:any = sessionStorage.getItem("loggedUser");
        if (user) {
            user = JSON.parse(user);
            this.loggedUser = user.data;
        }

        this.token = sessionStorage.getItem("token");
    }

    public gotoDashboard(id) {
        if (this.loggedUser) {
            if (this.loggedUser.groups.length) {
                if (this.loggedUser.groups[0] == this.EMPRESA) {
                    this.router.navigate(["/dashboard/empresas"]);
                }
                if (this.loggedUser.groups[0] == this.ALUNO) {
                    this.router.navigate(["/painel"]);
                }
                else if (this.loggedUser.groups[0] == this.EDUCADOR && id == null) {
                    this.router.navigate(["/educadores"]);
                }
                else if (this.loggedUser.groups[0] == this.EDUCADOR && id != null) {
                    this.router.navigate(['/educadores/projeto', id]);
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/services/global.service.ts